module.exports = __webpack_public_path__ + "img/3_AR.f66ba538.png";